import * as actionTypes from 'constants/action-types';
import { PageFilterContent } from 'store/ui/pageFilters/pageFilterTypes';

export type SetPageFilterAction = {
  type: typeof actionTypes.SET_PAGE_FILTER;
  payload: PageFilterContent;
};

export const setPageFilter = (filter: PageFilterContent) => {
  return (dispatch: any): any => {
    dispatch({
      type: actionTypes.SET_PAGE_FILTER,
      payload: filter,
    });
  };
};
